import React from "react";
import { LineChartTemplate } from "themes/common/components";

function LineChart(props) {
    return <LineChartTemplate {...props} />;
}

export default LineChart;
